// 商品订单详情
export default {
    heard_title: "Item Order Details",
    heard_btn: "Return",

    // 商品信息
    th_goodsInfo: "Goods Information",
    tl_goodsImg: "Goods Image",
    tl_goodsName: "Goods Name",
    tl_goodsPrice: "Price",
    tl_serial: "Item No.",
    tl_specName: "Spec",
    tl_quantity: "Quantity",
    tl_amount: "Subtotal",
    tl_total: "Total:",

    // 备注弹出框
    dt_memoOrder: "Memo Order",
    dt_closeOrder: "Close order",
    dp_memo: "remark",

    // 提示
    sm_closeOrder: "Close the order successfully",
    sm_memoOrder: "Memo order is successful"
};
